var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProvenResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#D4EAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.477 22.89L26.992 31.416C27.009 31.5164 26.9949 31.6196 26.9516 31.7118C26.9084 31.8039 26.838 31.8807 26.7499 31.9318C26.6619 31.9829 26.5603 32.0059 26.4588 31.9977C26.3573 31.9895 26.2607 31.9506 26.182 31.886L22.602 29.199C22.4292 29.0699 22.2192 29.0001 22.0035 29.0001C21.7878 29.0001 21.5778 29.0699 21.405 29.199L17.819 31.885C17.7403 31.9494 17.6439 31.9884 17.5425 31.9966C17.4411 32.0048 17.3397 31.9818 17.2517 31.9309C17.1636 31.8799 17.0933 31.8033 17.0499 31.7113C17.0066 31.6194 16.9923 31.5163 17.009 31.416L18.523 22.89",
    stroke: "#0071DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24C25.3137 24 28 21.3137 28 18C28 14.6863 25.3137 12 22 12C18.6863 12 16 14.6863 16 18C16 21.3137 18.6863 24 22 24Z",
    stroke: "#0071DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvenResult);
export default __webpack_public_path__ + "static/media/ProvenResult.e2f9ff27c2480abbf914043aa9df739c.svg";
export { ForwardRef as ReactComponent };